import tradeBlockDataStore from "@/store/tradeBlockDataStore";

/**
 * Get the transaction type (openClose) value for a block from Zustand store
 * Returns the value only for SWP instrument types
 */
export function getTransactionTypeValue(esid: string, blockId: number): string {
  const currentTradeBlockData = tradeBlockDataStore.getState().tradeBlockData;
  const theseBlocks = currentTradeBlockData.find(
    (blocks) => blocks.esid === esid,
  );
  const thisBlock = theseBlocks?.blocks?.find((block) => block.id === blockId);

  if (!thisBlock || thisBlock.instrumentType !== "SWP") {
    return "";
  }

  return thisBlock.openClose ?? "";
}

/**
 * AG Grid valueFormatter for TransactionType column copy/paste
 */
export function transactionTypeValueFormatter(params: any): string {
  const esid = params.colDef?.cellRendererParams?.fullTradeData?.esid;
  const blockId = params.data?.id;

  if (!esid || blockId == null) {
    return "";
  }

  return getTransactionTypeValue(esid, blockId);
}
